import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { apartmentStore } from './stores/store'
import ApartmentSearchForm from './components/ApartmentSearchForm'
import './i18n'
import './styles/search-apartments.scss'

let root = document.getElementById('trip-search-apartment');

ReactDOM.render(
    <Provider store={apartmentStore}>
        <ApartmentSearchForm
            customDestination={root.dataset.destination}
            facilities={root.dataset.facilities}
            feeding={root.dataset.feeding}
            operator={root.dataset.operator}
            hotelAttributes={root.dataset.hotelattributes}
            activityAttributes={root.dataset.activityattributes}
            sort={root.dataset.sort}
            standard={root.dataset.standard}
            minDays={root.dataset.mindays}
            maxDays={root.dataset.maxdays}
            priceMin={root.dataset.pricemin}
            priceMax={root.dataset.pricemax}
            priceFor={root.dataset.pricefor}
            accommodationTypes={JSON.parse(root.dataset.accommodationTypes || '{}')}
        />
    </Provider>,
    root
)
